export class SqlConfiguration {
  public key: string;
  public display_name: string;
  public connection_string: string;
  public use_credential_store: boolean;
  public is_production: boolean;
}
